import React from 'react';

const AddItemIcon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 2.28571C23.5429 2.28571 29.7143 8.45714 29.7143 16C29.7143 23.5429 23.5429 29.7143 16 29.7143C8.45714 29.7143 2.28571 23.5429 2.28571 16C2.28571 8.45714 8.45714 2.28571 16 2.28571ZM16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0Z" fill="#425B76" />
            <path d="M26 14.75H17.25V6H14.75V14.75H6V17.25H14.75V26H17.25V17.25H26V14.75Z" fill="#425B76" />
        </svg>
    )
}

export default AddItemIcon;